exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-title[data-v-321c3ce6] {\n    background-color: rgba(200,200,200,0.2);\n}\n\n", ""]);

// exports
